import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  main: {
    overflowY: 'auto',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
}));
